import React, { useState, useRef, useEffect } from "react";
import InputField from "../../InputField/InputField";
import Button from "../../Button/Button";
import UploadIcon from "./upload.svg";
import "./FileButton.scss";
import Cropper from "./Cropper";
import { Url2Base64Service } from "../../../utils/api";

const ImageField = ({ onChange, cropperUrl }) => {
  const [url, setUrl] = useState(cropperUrl);
  const [errors, setErrors] = useState({});
  const [cropUrl, setCropUrl] = useState(null);

  const inputRef = useRef(null);

  const handleUrlUpload = async () => {
    Url2Base64Service({ url })
      .then(resp => {
        setCropUrl(resp.url);
        setUrl("");
      })
      .catch(e => {
        const errors = e.errors || {
          image: ["Неизвестная ошибка: " + e.status]
        };
        setErrors(errors);
      });
  };

  useEffect(() => {
    if (cropperUrl) {
      handleUrlUpload();
    }
  }, [cropperUrl]);

  const handleFileUpload = async e => {
    const reader = new FileReader();

    reader.onload = function () {
      setCropUrl(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };

    reader.readAsDataURL(inputRef.current.files[0]);
  };

  const onCropDone = image => {
    onChange(image);
    setCropUrl(null);
  };

  const onCropperClose = () => {
    setCropUrl(null);
  };

  const imageErrors = (errors.image || []).concat(errors.url || []);

  return (
    <div className="teaser-form__image-upload">
      {cropUrl && (
        <Cropper
          onCropDone={onCropDone}
          onClose={onCropperClose}
          url={cropUrl}
        />
      )}

      <InputField
        label="Изображение"
        value={url}
        onChange={e => setUrl(e.target.value)}
        errors={imageErrors}
      />
      <Button
        color="green"
        className="upload-url"
        onClick={handleUrlUpload}
        disabled={!url}
      >
        Загрузить
      </Button>
      <div className="file-button">
        <input
          type="file"
          className="file-button__input"
          onChange={handleFileUpload}
          ref={inputRef}
        />
        <Button icon={UploadIcon} className="upload" color="light-blue" />
      </div>
    </div>
  );
};

export default ImageField;
